import {
  PolygonLayer,
  LayerEvent,
  MapScene,
  Control,
  ColorComponent,
  Popup,
} from "@antv/l7-react";
import React, { useEffect, useState } from "react";
import { usePapaParse } from "react-papaparse";
import { Box } from "@mui/system";
import DownloadButton from "../Common/DownloadButton";
import _ from "lodash";
import ModalTrigger from "../Common/ModalTrigger";
import makeStyles from "@mui/styles/makeStyles";
import MapTooltip from "./MapTooltip";

const useStyles = makeStyles((theme) => ({
  menuPaper: {
    maxHeight: "400px",
  },
}));

const ChapterThreeMap = (props) => {
  const [data, setData] = useState([]);
  const csv = props.csv;
  const { readString } = usePapaParse();
  const [hovered, setHovered] = useState(undefined);
  const [max, setMax] = useState(undefined);
  const [selectCounrty, setSelectCountry] = useState("");
  const classes = useStyles();
  const [groupCountries, setGroupCountries] = useState({});
  const [countrySelectStatus, setCountrySelectStatus] = useState({
    selected: false,
    country: undefined,
  });

  const handleReadString = () => {
    readString(csv, {
      complete: (results, file) => {
        props.json.features.map((j) => {
          let sum = 0;
          results.data
            .filter((d) => d["Country"] === j.properties["NAME"])
            .forEach((f) => {
              sum += f["Samples"];
            });

          const hasData = sum > 0;

          j.properties = {
            ...j.properties,
            sum: hasData ? sum : null, // or undefined
          };
          return j;
        });

        setData({ json: props.json, conv: results.data });
        setMax(Math.max(...props.json.features.map((f) => f.properties.sum)));
      },
      download: true,
      header: true,
      dynamicTyping: true,
      error: (error, file) => {
        console.log("Error while parsing:", error, file);
      },
    });
  };

  useEffect(() => {
    handleReadString();
  }, []);

  useEffect(() => {
    var grouped = _.mapValues(_.groupBy(data.conv, "Country"), (clist) =>
      clist.map((country) => _.omit(country, "Country"))
    );
    setGroupCountries(grouped);
  }, [data]);

  const [canvas, setCanvas] = useState(undefined);

  const getTooltipContent = (country) => {
    const found = data.conv.find((d) => d["Country"] === country);
    if (!found) {
      return (
        <div
          id="tooltipWrapper"
          style={{ padding: "10px", wordWrap: "break-word" }}
        >
          Number of samples: 0
        </div>
      );
    }
    const content = data.conv.filter((d) => d["Country"] === country);
    const sum = content
      .map((c) => c["Samples"])
      .reduce((partialSum, a) => partialSum + a, 0);
    const none = content
      .map((c) => c["Non-compliant"])
      .reduce((partialNone, a) => partialNone + a, 0);
    return (
      <div
        id="tooltipWrapper"
        style={{ padding: 0, wordWrap: "break-word", fontSize: "12px" }}
      >
        Number of samples: {sum.toLocaleString()}
      </div>
    );
  };

  const colors = [
    "#484D6A",
    "#BDBFC6",
    "#6F7389",
    "#9699A7",
    "#484D6A",
    "#22294D",
    "#22294D",
  ];

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 900);
  useEffect(() => {
    function handleResize() {
      setIsMobile(window.innerWidth <= 900);
    }
    window.addEventListener("resize", handleResize);
    return (_) => {
      window.removeEventListener("resize", handleResize);
    };
  });
  useEffect(() => {
    const canvases = document.getElementsByClassName("l7-marker-container");
    for (let i = 0; i < canvases.length; i++) {
      canvases[i].onwheel = function (event) {
        event.stopPropagation();
      };
    }
  });

  return (
    <Box>
      <Box
        sx={{
          display: { xs: "none", md: "contents" },
        }}
      >
        <Box
          display="flex"
          justifyContent="flex-end"
          alignItems="center"
          flexDirection="row"
        >
          <p
            className="titleChart"
            style={{
              fontFamily: "Roboto Condensed, sans-serif",
              marginBottom: ".5rem",
            }}
          >
            Number of samples taken per country of origin from all countries
          </p>
        </Box>
        <Box display="flex" justifyContent="flex-end" marginTop="5px">
          {data.conv && (
            <div
              className="legent-title"
              style={{
                fontFamily: "Roboto Condensed, sans-serif",
                minWidth: isMobile ? "250px" : "300px",
              }}
            >
              <ColorComponent
                items={[
                  { title: "0", color: "#D0D1D5" },
                  {
                    title: Math.round(max * 0.1).toLocaleString(),
                    color: "#BDBFC6",
                  },
                  {
                    title: Math.round(max * 0.3).toLocaleString(),
                    color: "#9699A7",
                  },
                  {
                    title: Math.round(max * 0.5).toLocaleString(),
                    color: "#6F7389",
                  },
                  {
                    title: Math.round(max * 0.6).toLocaleString(),
                    color: "#484D6A",
                  },
                  { title: Math.round(max).toLocaleString(), color: "#22294D" },
                ]}
              />
            </div>
          )}
          <Box pl="10px">
            <DownloadButton
              isMap
              canvas={canvas}
              fileName="Map"
              csv={data.conv}
            />
          </Box>
          <Box pl="10px">
            <ModalTrigger
              style={{ color: "#22294D", cursor: "pointer" }}
              text=""
            />
          </Box>
        </Box>
        <Box
          sx={{
            position: "absolute",

            /*
            right: { xs: 15, sm: 15, md: 150 },
            */

            left: { xs: 16, sm: 16, md: 15},
            top: { xs: 39, sm: 39, md: 308 },

            zIndex: 3,
          }}
        >


        </Box>
        {data.json && (
          <MapScene
            onSceneLoaded={(scene) => {
              setCanvas(scene);
            }}
            autoFit
            map={{
              pitch: 0,
              style: "blank",
              zoom: 2,
              minZoom: 2,
              maxZoom: 4,
              center: [112, 30],
            }}
            style={{
              height: "580px",
              position: "relative",
            }}
          >
            <PolygonLayer
              key={2}
              source={{
                data: data.json,
              }}
              color={{
                field: "sum",
                values: (d) => {
                  if (d == null) {
                    return "#fff";
                  } else if (d === 0) {
                    return colors[0];
                  } else if (d > 0 && d <= max * 0.1) {
                    return colors[1];
                  } else if (d > max * 0.1 && d <= max * 0.3) {
                    return colors[3];
                  } else if (d > max * 0.3 && d <= max * 0.5) {
                    return colors[4];
                  } else if (d > max * 0.5 && d <= max * 0.6) {
                    return colors[5];
                  } else {
                    return colors[6];
                  }
                },
              }}
              options={{
                autoFit: true,
              }}
              size={{
                values: 1,
              }}
              shape={{
                values: "fill",
              }}
              style={{
                opacity: 0.3,
                stroke: "#000",
                lineWidth: 1,
                lineOpacity: 0.1,
              }}
              active={{
                option: {
                  color: "#C6C2C2", //on hover
                },
              }}
              select={{
                option: {
                  color: "#C6C2C2",
                },
              }}
            >
              {hovered &&
                data.conv.find(
                  (d) => d["Country"] === hovered.feature.properties.NAME
                ) && (
                <MapTooltip>
                    <div id="tooltipWrapper">
                      {
                        <b
                          style={{
                            color: "#22294d",
                            fontWeight: "bold",
                            fontSize: "medium",
                            fontFamily: "Roboto Condensed",
                          }}
                        >
                          {hovered.feature.properties.NAME}
                        </b>
                      }
                      <br />
                      <div
                        id="tooltipInner"
                        style={{
                          color: "#22294d",
                          fontFamily: "Roboto Condensed",
                          fontSize: "15px",
                        }}
                      >
                        {getTooltipContent(hovered.feature.properties.NAME)}
                      </div>
                    </div>
                </MapTooltip>
                )}
              <LayerEvent
                type="click"
                handler={(e) => {
                  const state = {
                    country: e.feature.properties["NAME"],
                    data: data.conv.filter(
                      (d) => d["Country"] === e.feature.properties["NAME"]
                    ),
                  };
                  if (countrySelectStatus.country === e.feature.properties["NAME"]) {
                    setSelectCountry("");
                    setCountrySelectStatus({
                      selected: false,
                      country: undefined,
                    });
                    props.onCountryClick(undefined);
                  } else {
                    setSelectCountry(state.country);
                    setCountrySelectStatus({
                      selected: true,
                      country: state.country,
                    });
                    props.onCountryClick(state);
                  }
                }}
              />
              <LayerEvent
                type="mouseenter"
                handler={(e) => {
                  setHovered(e);
                }}
              />
              <LayerEvent
                type="mouseout"
                handler={(e) => {
                  setHovered(undefined);
                }}
              />
            </PolygonLayer>
            <PolygonLayer
              key={1}
              source={{
                data: data.json,
              }}
              size={{
                values: 0.5,
              }}
              color={{
                values: "#fff", //outline of the map
              }}
              shape={{
                values: "line",
              }}
              style={{
                opacity: 0.5,
              }}
            />
            <Control type="scale" position="bottomright" />
            <Control type="zoom" position="bottomright" />
          </MapScene>
        )}
      </Box>
      <Box
        sx={{
          display: { xs: "contents", md: "none" },
        }}
      >
        <Box
          display="flex"
          justifyContent="flex-start"
          alignItems="center"
          flexDirection="row"
        >
          <p
            className="titleChart"
            style={{
              fontFamily: "Roboto Condensed, sans-serif",
              marginBottom: ".5rem",
              opacity: 0.8,
            }}
          >
            Select a country to filter the results below
          </p>
        </Box>
      </Box>
    </Box>
  );
};

export default ChapterThreeMap;
